import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedGossip from './components/FeaturedGossip';
import LatestUpdates from './components/LatestUpdates';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedGossip />
        <LatestUpdates />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}